import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import { IoCameraOutline } from "react-icons/io5";
import { TbFileDownload } from "react-icons/tb";
import { idSkel } from "../../../../assets/images";
import { FaRegTimesCircle } from "react-icons/fa";
import useAuthAxios from "../../../../utils/baseAxios";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../../constants/api";
import { errorMessage } from "../../../../utils/errorMessage";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";

const UploadGovId = ({
  setScreen,
  document,
  setGovIdFile,
  govIdFile,
  govSignedUrl,
  setGovSignedUrl,
  setGovObjectUrl,
}: any) => {
  const webcamRef = useRef<Webcam | null>(null);
  const [showWebcam, setShowWebcam] = useState(false);
  const [photo, setPhoto] = useState<string | null>(null);
  const [uploaded, setUploaded] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();

  const handleCapture = useCallback(() => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setPhoto(imageSrc);

      // Convert base64 image to file
      if (imageSrc) {
        const byteString = atob(imageSrc.split(",")[1]);
        const mimeString = imageSrc.split(",")[0].split(":")[1].split(";")[0];
        const arrayBuffer = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
          arrayBuffer[i] = byteString.charCodeAt(i);
        }
        const file = new File([arrayBuffer], "captured-photo.jpg", {
          type: mimeString,
        });
        setGovIdFile(file);
        if (govSignedUrl !== "") {
          completeIdUpload.mutate({
            file,
          });
        }
      }
      setShowWebcam(false);
    }
  }, [govSignedUrl, setGovIdFile]);
  //   console.log(govIdFile);
  const getUploadUrl = async (data: any) => {
    const response = await axiosInstance.post(API.getKyc3UploadURL, data);
    return response.data;
  };
  const completeGetUU = useMutation({
    mutationFn: getUploadUrl,
    onSuccess: (r) => {
      // toast.success(r.message);
      setGovObjectUrl(r.data.objectURL);
      setGovSignedUrl(r.data.signedURL);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      setGovObjectUrl("");
      setGovSignedUrl("");
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  const uploadImage = async ({ file }: any) => {
    const response = await axios.put(`${govSignedUrl}`, file, {
      headers: {
        "Content-Type": file.type, // Set content type to the MIME type of the file
      },
    });
    return response.data;
  };
  const completeIdUpload = useMutation({
    mutationFn: uploadImage,
    onSuccess: (r) => {
      // console.log(r);
      setUploaded(true);
      toast.success(`Document uploaded successfully`);
    },
    onError: (e) => {
      // console.log(e);
      setUploaded(false);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  // console.log(uploaded);

  return (
    <div className="w-full font-manrope">
      <div className="flex w-full gap-2 justify-start items-center">
        <div className="w-[24px] h-[24px] rounded-full border-[0.5px] border-[#0B75C2] bg-[#E9F1FF]  font-sora text-secondary_button text-[10px] flex justify-center items-center">
          1
        </div>
        <h4 className="text-[12px] text-black dark:text-white font-sora font-bold">
          Govt ID
        </h4>
        <div className="bg-[#E5E7EB] dark:bg-gray-500 w-[2px] h-4 rounded-full"></div>
        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          2
        </div>
        <div className="w-[24px] h-[24px] rounded-full bg-[#EBEBEB] font-sora text-gray-600 dark:text-gray-400 dark:bg-gray-600 text-[10px] flex justify-center items-center">
          3
        </div>
      </div>
      <div className="w-full mt-10">
        <h4 className="text-black dark:text-white text-center font-semibold font-sora text-[16px]">
          {document}
        </h4>
        <div className="mt-6 border-dashed border-gray-200 border rounded-xl p-4">
          <h4 className="text-gray-600 dark:text-gray-400 text-[13px] font-semibold">
            Main Side
          </h4>

          <div className="mt-12 flex flex-col justify-center items-center">
            {showWebcam ? (
              <>
                <Webcam
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  videoConstraints={{
                    facingMode: { ideal: "environment" },
                  }}
                  className="w-full max-w-sm rounded-md"
                />
                <button
                  onClick={handleCapture}
                  className="w-full mt-4 rounded-lg h-[40px] bg-secondary_button flex justify-center items-center gap-2 text-white"
                >
                  Capture Photo
                </button>
              </>
            ) : govIdFile ? (
              <div>
                <img
                  src={URL.createObjectURL(govIdFile)}
                  alt="Captured"
                  className="w-60 h-60 object-cover rounded-md"
                />
                <button
                  onClick={() => {
                    setPhoto(null);

                    setGovIdFile(null);
                    setUploaded(false);
                  }}
                  className="mt-4 w-full h-[40px] flex gap-2 justify-center items-center mx-auto bg-transparent border border-[#D92B2B] rounded-xl text-[#D92B2B] font-medium text-[15px] "
                >
                  <FaRegTimesCircle className="" />
                  Retake Image
                </button>
              </div>
            ) : (
              <>
                <div className="mx-auto">
                  <img src={idSkel} className="" alt="" />
                </div>
                <button
                  onClick={() => {
                    const data = {
                      documentType: "governmentID",
                    };
                    completeGetUU.mutate(data);
                    setShowWebcam(!showWebcam);
                  }}
                  className="w-1/2 mt-4 rounded-lg h-[40px] bg-secondary_button flex justify-center items-center gap-2 text-white"
                >
                  <IoCameraOutline />
                  <h4 className="text-[11px]">
                    {showWebcam ? "Close Camera" : "Take a Photo"}
                  </h4>
                </button>

                <div
                  onClick={() => {
                    const data = {
                      documentType: "governmentID",
                    };
                    completeGetUU.mutate(data);
                  }}
                  className="relative inline-block cursor-pointer w-1/2 mt-4"
                >
                  <label htmlFor="image-upload" className="cursor-pointer">
                    <button className="w-full rounded-lg h-[40px] bg-[#D4EBFD] flex justify-center items-center gap-2 text-secondary_button">
                      <TbFileDownload />
                      <h4 className="text-[11px]">Upload File</h4>
                    </button>
                  </label>
                  <input
                    type="file"
                    id="image-upload"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files ? e.target.files[0] : null;
                      if (file) {
                        setGovIdFile(file);
                        if (govSignedUrl !== "") {
                          completeIdUpload.mutate({
                            file,
                          });
                        }
                      }
                    }}
                    className="absolute w-[99%] top-0 left-0 opacity-0 h-10"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <h4 className="text-gray-400 mt-4 text-center text-[12px]">
          File size must be between 100kb and 8mb
        </h4>
        <h4 className="text-gray-400 mt-2 text-center text-[12px]">
          jpg / jpeg / png format
        </h4>
        <button
          disabled={(!photo && !govIdFile) || !uploaded}
          onClick={() => setScreen(4)}
          className={
            (!photo && !govIdFile) || !uploaded
              ? "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-gray-200 rounded-xl bg-gray-400"
              : "w-full h-[52px] flex justify-center text-[15px] items-center mt-8 font-semibold text-white rounded-xl bg-secondary_button"
          }
        >
          {completeIdUpload.isPending ? (
            <div className="bg-transparent flex justify-center gap-2 items-center">
              Uploading
              <ClipLoader color="#ffffff" size={20} />
            </div>
          ) : (
            "Next"
          )}
        </button>
      </div>
    </div>
  );
};

export default UploadGovId;
